// const base_url = "http://localhost:8080/yunsu/";
const base_url = "https://www.longtanruzhu.com/api/";
export default {
    base_url,
}
